/**
 * Controller: batchClient
 */
/*
 runResourceSchedule: function() {
 $.ajax({
 url: '/v1/api/entity/schedules/analytics/loadData',
 success: function() {
 console.log('UsersViewController::schedule::success');
 }
 });
 }
 */

angular.module('acme.common.controller.batchClient', [])
.controller('BatchClientController', [ '$scope', function($scope) {

    $scope.batchClient = {

      init: function() {},

      runEventSchedule: function() {
        $.ajax({
          url: '/v1/api/batch/event/createInstances',
          success: function() {
            console.log('BatchClientController::runEventSchedule');
          }
        });
      },

      runOrderAnalyticsLoadDataSchedule: function() {
          $.ajax({
              url: '/v1/api/b2c/orders/analytics/loadData',
              success: function () {
                  console.log('BatchClientController::orderAnalyticsLoadData::success');
              }
          });
      },

      runResourceAnalyticsLoadDataSchedule: function() {
        $.ajax({
            url: '/v1/api/entity/schedules/analytics/loadData',
            success: function () {
                console.log('BatchClientController::resourceAnalyticsLoadData::success');
            }
        });
      },

      runMigrationMVP1367: function() {
        $.ajax({
            url: '/v1/api/migration/orders/MVP_1367',
            success: function () {
                console.log('BatchClientController::migrationMVP1367::success');
            }
        });
      }

    };

}]);